import { LanguageCode } from "@/shared/config/languages";

type TranslationMap = Record<string, string>;

export const UI_TRANSLATIONS: Partial<Record<LanguageCode, TranslationMap>> = {
  cs: {
    "nav.dashboard": "Přehled",
    "nav.factoryDashboard": "Přehled továrny",
    "nav.aiControl": "AI řízení výroby",
    "nav.workInstructions": "Pracovní instrukce",
    "nav.qualityChecks": "Kontroly kvality",
    "nav.defectTagging": "Značení vad",
    "nav.shiftReports": "Směnové reporty",
    "nav.performance": "Výkon",
    "nav.competency": "Kompetence",
    "nav.eightD": "Reklamace",
    "nav.supplierQuality": "Dodavatelé",
    "nav.customerComplaints": "Reklamace",
    "nav.processAudits": "Procesní audity",
    "nav.energy": "Energetika",
    "nav.documentAssistant": "Asistent dokumentů",
    "nav.adminHeading": "Administrace",
    "nav.userManagement": "Správa uživatelů",
    "nav.roleManagement": "Správa rolí",
    "nav.factoryStructure": "Struktura provozu",
    "nav.unsMapper": "UNS mapování",
    "nav.group.dashboards": "Dashboardy",
    "nav.group.supplierManagement": "Řízení dodavatelů",
    "nav.group.customerManagement": "Řízení zákazníků",
    "nav.group.people": "Lidé",
    "nav.group.toBeRemoved": "K odstranění",
    "nav.group.efficiency": "Efektivita",
    "nav.group.quality": "Kvalita",
    "nav.group.other": "Ostatní",
    "nav.lpa": "LPA Audity",

    "dashboard.title": "Kvalitativní přehled",
    "dashboard.subtitle": "Vítejte zpět! Zde je váš dnešní přehled kvality výroby.",
    "dashboard.kpi.trend": "vs. minulá směna",
    "dashboard.kpi.oee.title": "OEE (Celková efektivita zařízení)",
    "dashboard.kpi.fpy.title": "FPY (Průchodnost na první pokus)",
    "dashboard.kpi.scrap.title": "Míra zmetkovitosti",
    "dashboard.kpi.cycleTime.title": "Průměrný cyklus",
    "dashboard.modulesHeading": "Moduly kvality",

    "dashboard.module.startup.title": "Digitální náběh",
    "dashboard.module.startup.description": "Kontrolní seznamy náběhu zařízení a ověření připravenosti.",
    "dashboard.module.startup.stats": "Čeká na náběh",
    "dashboard.module.instructions.title": "Pracovní instrukce",
    "dashboard.module.instructions.description": "Postupy SMC, drapování CFK, příprava nástrojů a lepení.",
    "dashboard.module.instructions.stats": "Aktivní instrukce",
    "dashboard.module.qualityChecks.title": "Kontroly kvality",
    "dashboard.module.qualityChecks.description": "Průběžné i výstupní inspekce kvality.",
    "dashboard.module.qualityChecks.stats": "Kontroly dnes",
    "dashboard.module.defects.title": "Značení vad",
    "dashboard.module.defects.description": "Digitální zachycení a sledování vad.",
    "dashboard.module.defects.stats": "Otevřené vady",
    "dashboard.module.shiftReports.title": "Směnové reporty",
    "dashboard.module.shiftReports.description": "Digitální předávky a směnová dokumentace.",
    "dashboard.module.shiftReports.stats": "Reporty dnes",
    "dashboard.module.performance.title": "Přehled výkonu",
    "dashboard.module.performance.description": "OEE, FPY, zmetkovitost a doby cyklu s analytikou.",
    "dashboard.module.performance.stats": "Vygenerované reporty",
    "dashboard.module.competency.title": "Správa kompetencí",
    "dashboard.module.competency.description": "Matrice dovedností a sledování školení.",
    "dashboard.module.competency.stats": "Aktivní zaměstnanci",
    "dashboard.module.eightD.title": "8D řízení",
    "dashboard.module.eightD.description": "Dodavatelská kvalita a nápravná opatření.",
    "dashboard.module.eightD.stats": "Otevřená 8D",
    "dashboard.module.customerComplaints.title": "Zákaznické reklamace",
    "dashboard.module.customerComplaints.description": "Evidence a vyřízení reklamací od zákazníků.",
    "dashboard.module.audits.title": "LPA Audity",
    "dashboard.module.audits.description": "Řízení vrstvených procesních auditů.",
    "dashboard.module.audits.stats": "Audity tento měsíc",

    "module.back": "Zpět na přehled",
    "module.placeholder.title": "Modul ve vývoji",
    "module.placeholder.description": "Tento modul se právě připravuje. Brzy přidáme kompletní funkce včetně formulářů, tabulek a reportů.",
    "module.placeholder.request": "Požádat o funkci",
    "module.placeholder.docs": "Zobrazit dokumentaci",

    "module.preview.dataEntry": "Zadávání dat",
    "module.preview.dataEntry.desc": "Digitální formuláře s validací a automatickým ukládáním",
    "module.preview.analytics": "Analytika",
    "module.preview.analytics.desc": "Dashboardy v reálném čase a trendová analýza",
    "module.preview.reports": "Reporty",
    "module.preview.reports.desc": "Automatizované generování a export reportů",

    "mod_energy.energy_management.title": "Řízení energie",

    // LPA Module
    "mod_lpa.management.title": "LPA Audity",
    "mod_lpa.management.subtitle": "Řízení vrstvených procesních auditů dle AIAG CQI-8",
    "mod_lpa.management.noFactory": "Není vybraná továrna",
    "mod_lpa.management.noFactoryDescription": "Pro správu LPA auditů vyberte továrnu.",
    "mod_lpa.management.tabs.dashboard": "Přehled",
    "mod_lpa.management.tabs.audits": "Audity",
    "mod_lpa.management.tabs.questions": "Otázky",
    "mod_lpa.management.tabs.schedules": "Plánování",
    "mod_lpa.management.tabs.myAudits": "Moje audity",
    "mod_lpa.management.tabs.settings": "Nastavení",
    "mod_lpa.dashboard.title": "Přehled auditů",
    "mod_lpa.dashboard.description": "Míra dokončení, trendy shody a klíčové metriky napříč vrstvami auditů.",
    "mod_lpa.dashboard.placeholder": "Metriky přehledu se zobrazí po konfiguraci a dokončení auditů.",
    "mod_lpa.audits.title": "Definice auditů",
    "mod_lpa.audits.description": "Správa definic auditů vázaných na konkrétní lokace továrny.",
    "mod_lpa.audits.placeholder": "Vytvořte první definici auditu.",

    // LPA Audits — status
    "mod_lpa.audits.status.draft": "Návrh",
    "mod_lpa.audits.status.active": "Aktivní",
    "mod_lpa.audits.status.archived": "Archivovaný",

    // LPA Audits — list page
    "mod_lpa.audits.scopedLocation": "Omezená lokace",
    "mod_lpa.audits.entireFactory": "Celá továrna",
    "mod_lpa.audits.unknownOwner": "Neznámý",
    "mod_lpa.audits.owner": "Vlastník",
    "mod_lpa.audits.scheduleCount": "plán(y)",
    "mod_lpa.audits.noResults": "Žádné audity neodpovídají filtrům",
    "mod_lpa.audits.emptyTitle": "Zatím žádné audity",
    "mod_lpa.audits.noResultsHint": "Zkuste upravit vyhledávání nebo filtr stavu.",
    "mod_lpa.audits.emptyHint": "Vytvořte první definici auditu pro zahájení plánování vrstvených procesních auditů v této továrně.",
    "mod_lpa.audits.filterAll": "Vše",
    "mod_lpa.audits.filterDraft": "Návrhy",
    "mod_lpa.audits.filterActive": "Aktivní",
    "mod_lpa.audits.filterArchived": "Archivované",
    "mod_lpa.audits.createButton": "Nový audit",
    "mod_lpa.audits.infoTitle": "Definice auditů",
    "mod_lpa.audits.infoDescription": "Každý audit definuje, co a kde se audituje. Přidejte plány k auditu pro určení kdo, jak často a které otázky. Audity v návrhu slouží k plánování — aktivujte je, když budou připraveny.",
    "mod_lpa.audits.searchPlaceholder": "Hledat audity...",
    "mod_lpa.audits.showing": "Zobrazeno auditů",

    // LPA Audits — detail page
    "mod_lpa.audits.detail.notFound": "Audit nenalezen",
    "mod_lpa.audits.detail.notFoundHint": "Tento audit mohl být smazán nebo k němu nemáte přístup.",
    "mod_lpa.audits.detail.backToList": "Zpět na audity",
    "mod_lpa.audits.detail.breadcrumbAudits": "Audity",
    "mod_lpa.audits.detail.edit": "Upravit",
    "mod_lpa.audits.detail.activate": "Aktivovat",
    "mod_lpa.audits.detail.activateHint": "Aktivací auditu se spustí generování instancí z jeho plánů. Ujistěte se, že jsou plány nejprve nakonfigurovány.",
    "mod_lpa.audits.detail.archive": "Archivovat",
    "mod_lpa.audits.detail.archiveHint": "Archivace zastaví budoucí generování instancí, ale zachová všechna historická data a dokončení.",
    "mod_lpa.audits.detail.ownerLabel": "Vlastník",
    "mod_lpa.audits.detail.locationLabel": "Lokace",
    "mod_lpa.audits.detail.schedulesLabel": "Plány",
    "mod_lpa.audits.detail.noSchedules": "Žádné nakonfigurované",
    "mod_lpa.audits.detail.scheduleSuffix": "plán(y)",
    "mod_lpa.audits.detail.createdLabel": "Vytvořeno",
    "mod_lpa.audits.detail.schedulesTitle": "Plány",
    "mod_lpa.audits.detail.schedulesDescription": "Opakující se plány auditů definují, kdo audituje, jak často a které otázky. Každý plán představuje vrstvu (např. operátor denně, nadřízený týdně).",
    "mod_lpa.audits.detail.schedulesPlaceholder": "Správa plánů bude dostupná v příští aktualizaci. Zde budete moci definovat vrstvy s frekvencí, auditorem a přiřazením otázek.",
    "mod_lpa.audits.detail.deleteTitle": "Smazat audit?",
    "mod_lpa.audits.detail.deleteDescription": "Trvale smaže tento audit a všechny jeho plány. Tuto akci nelze vrátit zpět.",
    "mod_lpa.audits.detail.deleteCancel": "Zrušit",
    "mod_lpa.audits.detail.deleteConfirm": "Smazat",

    // LPA Audits — form dialog
    "mod_lpa.audits.form.loadingUsers": "Načítání uživatelů...",
    "mod_lpa.audits.form.selectOwner": "Vyberte vlastníka...",
    "mod_lpa.audits.form.searchUsers": "Hledat podle jména nebo e-mailu...",
    "mod_lpa.audits.form.noUsersFound": "Žádní uživatelé nenalezeni.",
    "mod_lpa.audits.form.editTitle": "Upravit audit",
    "mod_lpa.audits.form.createTitle": "Nový audit",
    "mod_lpa.audits.form.editDescription": "Aktualizujte definici auditu. Změny rozsahu lokace se projeví pouze u budoucích instancí plánů.",
    "mod_lpa.audits.form.createDescription": "Definujte nový audit pro tuto továrnu. Začněte jako návrh a přidejte plány před aktivací.",
    "mod_lpa.audits.form.nameLabel": "Název auditu",
    "mod_lpa.audits.form.nameHint": "Popisný název auditu, např. 'Montážní linka A – denní kontrola' nebo 'Lakovna – týdenní audit'.",
    "mod_lpa.audits.form.namePlaceholder": "např. Montážní linka A – denní kontrola",
    "mod_lpa.audits.form.descriptionLabel": "Popis",
    "mod_lpa.audits.form.descriptionHint": "Volitelné poznámky o účelu nebo rozsahu auditu. Viditelné pro nadřízené plánující plány.",
    "mod_lpa.audits.form.descriptionPlaceholder": "Co tento audit pokrývá a proč...",
    "mod_lpa.audits.form.ownerLabel": "Vlastník",
    "mod_lpa.audits.form.ownerHint": "Osoba odpovědná za tuto definici auditu. Spravuje plány a dostává upozornění na eskalace.",
    "mod_lpa.audits.form.locationLabel": "Rozsah lokace",
    "mod_lpa.audits.form.locationHint": "Zužte audit na konkrétní oblast, linku nebo stanici. Ponechte prázdné pro audit celé továrny. Plány pod tímto auditem dědí rozsah.",
    "mod_lpa.audits.form.cancel": "Zrušit",
    "mod_lpa.audits.form.saveChanges": "Uložit změny",
    "mod_lpa.audits.form.create": "Vytvořit audit",

    // LPA Audits — toast messages
    "mod_lpa.audits.createSuccess": "Audit vytvořen",
    "mod_lpa.audits.createError": "Nepodařilo se vytvořit audit",
    "mod_lpa.audits.updateSuccess": "Audit aktualizován",
    "mod_lpa.audits.updateError": "Nepodařilo se aktualizovat audit",
    "mod_lpa.audits.deleteSuccess": "Audit smazán",
    "mod_lpa.audits.deleteError": "Nepodařilo se smazat audit",
    "mod_lpa.questions.title": "Banka otázek",
    "mod_lpa.questions.description": "Správa kontrolních otázek shody se štítky a pokyny pro auditory.",
    "mod_lpa.questions.placeholder": "Přidejte kontrolní otázky pro sestavení banky otázek.",
    "mod_lpa.schedules.title": "Přehled plánování",
    "mod_lpa.schedules.description": "Zobrazení nadcházejících instancí auditů, přiřazení auditorů a sledování dokončení.",
    "mod_lpa.schedules.placeholder": "Plány se zobrazí po konfiguraci auditů s opakujícími se pravidly.",

    // LPA My Audits & completion flow
    "mod_lpa.myAudits.title": "Moje audity",
    "mod_lpa.myAudits.description": "Provádějte přiřazené audity, ukládejte důkazy a dokončujte je v jednom toku.",
    "mod_lpa.myAudits.help": "Nejdříve se zobrazují po termínu. Spusťte nebo pokračujte v auditu, odpovídejte otázky po jedné a přikládejte důkazy.",
    "mod_lpa.myAudits.assigned": "Přiřazené audity",
    "mod_lpa.myAudits.onTrack": "V normě",
    "mod_lpa.myAudits.urgencyHint": "Seřazeno podle naléhavosti: nejdříve nejvíce po termínu, potom nejbližší termíny.",
    "mod_lpa.myAudits.overdue": "Po termínu",
    "mod_lpa.myAudits.noneOverdue": "Žádné audity po termínu.",
    "mod_lpa.myAudits.upcoming": "Dnes / Nadcházející",
    "mod_lpa.myAudits.noneUpcoming": "Žádné přiřazené nadcházející audity.",
    "mod_lpa.myAudits.completed": "Dokončeno (7 dní)",
    "mod_lpa.myAudits.noneCompleted": "Žádné nedávno dokončené audity.",
    "mod_lpa.myAudits.finishedAt": "Dokončeno",
    "mod_lpa.myAudits.start": "Spustit audit",
    "mod_lpa.myAudits.continue": "Pokračovat",
    "mod_lpa.completions.loading": "Načítání průběhu auditu...",
    "mod_lpa.completions.loadingTitle": "Provádění auditu",
    "mod_lpa.completions.startSuccess": "Audit spuštěn",
    "mod_lpa.completions.startError": "Audit se nepodařilo spustit",
    "mod_lpa.completions.saveResponseError": "Odpověď se nepodařilo uložit",
    "mod_lpa.completions.completeSuccess": "Audit dokončen",
    "mod_lpa.completions.completeError": "Audit se nepodařilo dokončit",
    "mod_lpa.completions.cancelSuccess": "Audit zrušen",
    "mod_lpa.completions.cancelError": "Audit se nepodařilo zrušit",
    "mod_lpa.completions.answerBeforeAttachment": "Nejprve odpovězte na otázku",
    "mod_lpa.completions.answerBeforeAttachmentHint": "Před nahráním přílohy nastavte stav shody.",
    "mod_lpa.completions.doneTitle": "Audit dokončen",
    "mod_lpa.completions.doneHint": "Skvělá práce. Audit je uzavřen a viditelný v historii dokončených.",
    "mod_lpa.completions.backToList": "Zpět na moje audity",
    "mod_lpa.completions.questionXofY": "Otázka {current} z {total}",
    "mod_lpa.completions.reactionPlan": "Reakční plán",
    "mod_lpa.completions.conforming": "V souladu",
    "mod_lpa.completions.nonConforming": "Neshoda",
    "mod_lpa.completions.notApplicable": "N/A",
    "mod_lpa.completions.skip": "Přeskočit",
    "mod_lpa.completions.moreOptions": "Další možnosti",
    "mod_lpa.completions.commentPlaceholder": "Přidejte komentář nebo zjištění...",
    "mod_lpa.completions.saveComment": "Uložit komentář",
    "mod_lpa.completions.addAttachment": "Přidat přílohu",
    "mod_lpa.completions.takePhoto": "Pořídit fotku",
    "mod_lpa.completions.sessionNotes": "Poznámky k auditu",
    "mod_lpa.completions.sessionNotesHint": "Volitelné celkové poznámky k této auditní relaci.",
    "mod_lpa.completions.notesPlaceholder": "Obecná pozorování...",
    "mod_lpa.completions.complete": "Dokončit audit",
    "mod_lpa.completions.cancel": "Zrušit audit",
    "mod_lpa.completions.noQuestions": "Pro tuto instanci nejsou aktivní otázky.",
    "mod_lpa.attachments.uploadSuccess": "Příloha nahrána",
    "mod_lpa.attachments.uploadError": "Přílohu se nepodařilo nahrát",
    "mod_lpa.attachments.deleteSuccess": "Příloha smazána",
    "mod_lpa.attachments.deleteError": "Přílohu se nepodařilo smazat",

    "mod_lpa.settings.title": "Nastavení LPA",
    "mod_lpa.settings.description": "Konfigurujte nastavení LPA auditů specifická pro závod.",
    "mod_lpa.settings.placeholder": "Zde budou konfigurovány nastavení LPA závodu, jako jsou pravidla plánování a časování eskalací.",
    "mod_lpa.settings.save": "Uložit změny",
    "mod_lpa.settings.reset": "Obnovit",
    "mod_lpa.settings.saveSuccess": "Nastavení uložena",
    "mod_lpa.settings.saveError": "Nepodařilo se uložit nastavení",
    "mod_lpa.settings.defaultsHint": "Pro tuto továrnu zatím nebyla uložena žádná vlastní nastavení. Níže uvedené hodnoty jsou systémové výchozí. Upravte a uložte pro přizpůsobení.",
    "mod_lpa.settings.schedule.title": "Konfigurace plánování",
    "mod_lpa.settings.schedule.description": "Nastavte generování plánů auditů a začátek pracovního týdne.",
    "mod_lpa.settings.weekStartDay": "Den začátku týdne",
    "mod_lpa.settings.weekStartDayTooltip": "První den auditního týdne. Týdenní audity budou plánovány od tohoto dne.",
    "mod_lpa.settings.eobHour": "Konec pracovní doby",
    "mod_lpa.settings.eobHourTooltip": "Denní auditní okna se uzavírají v tuto hodinu (24h formát). Audity naplánované na daný den musí být dokončeny před tímto časem.",
    "mod_lpa.settings.leadDays": "Předstih generování",
    "mod_lpa.settings.leadDaysTooltip": "Kolik dní předem se generují jednotlivé instance auditů z opakujících se plánů. Vyšší hodnota dává auditorům lepší přehled o nadcházejících auditech.",
    "mod_lpa.settings.days": "dní",
    "mod_lpa.settings.hours": "hodin",
    "mod_lpa.settings.notifications.title": "Připomínky",
    "mod_lpa.settings.notifications.description": "Nastavte, kdy auditoři obdrží připomínky o nadcházejících instancích auditů.",
    "mod_lpa.settings.reminderHours": "Předstih připomínky",
    "mod_lpa.settings.reminderHoursTooltip": "Počet hodin před termínem auditu, kdy je auditorovi odeslána připomínka. Nastavte 0 pro vypnutí připomínek.",
    "mod_lpa.settings.escalation.title": "Eskalace",
    "mod_lpa.settings.escalation.description": "Definujte, kdy po zmeškání auditu dojde k eskalaci na nadřízené.",
    "mod_lpa.settings.escalationHours": "Zpoždění eskalace",
    "mod_lpa.settings.escalationHoursTooltip": "Počet hodin po zmeškání termínu auditu, než je odesláno upozornění na eskalaci odpovědnému nadřízenému.",
    "mod_lpa.settings.day.sunday": "Neděle",
    "mod_lpa.settings.day.monday": "Pondělí",
    "mod_lpa.settings.day.tuesday": "Úterý",
    "mod_lpa.settings.day.wednesday": "Středa",
    "mod_lpa.settings.day.thursday": "Čtvrtek",
    "mod_lpa.settings.day.friday": "Pátek",
    "mod_lpa.settings.day.saturday": "Sobota",

    // LPA Questions
    "mod_lpa.questions.filterByTag": "Štítky:",
    "mod_lpa.questions.clearFilters": "Vymazat",
    "mod_lpa.questions.noResults": "Žádné otázky neodpovídají filtrům",
    "mod_lpa.questions.emptyTitle": "Zatím žádné otázky",
    "mod_lpa.questions.noResultsHint": "Zkuste upravit vyhledávání nebo filtry štítků.",
    "mod_lpa.questions.emptyHint": "Vytvořte první kontrolní otázku pro sestavení banky otázek.",
    "mod_lpa.questions.searchPlaceholder": "Hledat otázky...",
    "mod_lpa.questions.statusAll": "Všechny",
    "mod_lpa.questions.statusActive": "Aktivní",
    "mod_lpa.questions.statusInactive": "Neaktivní",
    "mod_lpa.questions.addQuestion": "Přidat otázku",
    "mod_lpa.questions.showing": "Zobrazeno otázek",
    "mod_lpa.questions.deleteTitle": "Smazat otázku?",
    "mod_lpa.questions.deleteDescription": "Trvale smaže tuto otázku a odstraní ji ze všech auditů. Tuto akci nelze vrátit zpět.",
    "mod_lpa.questions.cancel": "Zrušit",
    "mod_lpa.questions.confirmDelete": "Smazat",
    "mod_lpa.questions.editTitle": "Upravit otázku",
    "mod_lpa.questions.createTitle": "Nová otázka",
    "mod_lpa.questions.questionLabel": "Otázka *",
    "mod_lpa.questions.questionPlaceholder": "např. Je pracoviště čisté a bez nečistot?",
    "mod_lpa.questions.explanationLabel": "Vysvětlení / Pokyny",
    "mod_lpa.questions.explanationPlaceholder": "Pokyny pro auditory, co kontrolovat...",
    "mod_lpa.questions.reactionPlanLabel": "Reakční plán",
    "mod_lpa.questions.reactionPlanPlaceholder": "Kroky při zjištění neshody...",
    "mod_lpa.questions.tagsLabel": "Štítky",
    "mod_lpa.questions.durationLabel": "Odhad. doba",
    "mod_lpa.questions.activeLabel": "Aktivní",
    "mod_lpa.questions.saveChanges": "Uložit změny",
    "mod_lpa.questions.create": "Vytvořit otázku",
    "mod_lpa.questions.inactive": "Neaktivní",
    "mod_lpa.questions.explanation": "Vysvětlení / Pokyny",
    "mod_lpa.questions.noExplanation": "Vysvětlení nebylo poskytnuto",
    "mod_lpa.questions.reactionPlan": "Reakční plán",
    "mod_lpa.questions.noReactionPlan": "Reakční plán nebyl poskytnut",
    "mod_lpa.questions.noDetails": "Žádné další podrobnosti k této otázce.",
    "mod_lpa.questions.createSuccess": "Otázka vytvořena",
    "mod_lpa.questions.createError": "Nepodařilo se vytvořit otázku",
    "mod_lpa.questions.updateSuccess": "Otázka aktualizována",
    "mod_lpa.questions.updateError": "Nepodařilo se aktualizovat otázku",
    "mod_lpa.questions.deleteSuccess": "Otázka smazána",
    "mod_lpa.questions.deleteError": "Nepodařilo se smazat otázku",

    // LPA Tags
    "mod_lpa.tags.toggleActive": "Přepnout aktivní",
    "mod_lpa.tags.nameEn": "Název (anglicky)",
    "mod_lpa.tags.namePlaceholder": "např. Bezpečnost, Kvalita, 5S...",
    "mod_lpa.tags.nameSecondary": "Název (překlad)",
    "mod_lpa.tags.nameSecondaryPlaceholder": "Překlad...",
    "mod_lpa.tags.color": "Barva",
    "mod_lpa.tags.save": "Uložit",
    "mod_lpa.tags.cancel": "Zrušit",
    "mod_lpa.tags.title": "Štítky otázek",
    "mod_lpa.tags.description": "Organizujte otázky pomocí barevných štítků. Štítky jsou sdíleny mezi všemi továrnami.",
    "mod_lpa.tags.addTag": "Přidat štítek",
    "mod_lpa.tags.empty": "Zatím žádné štítky. Vytvořte první štítek pro organizaci otázek.",
    "mod_lpa.tags.inactive": "Neaktivní",
    "mod_lpa.tags.deleteTitle": "Smazat štítek?",
    "mod_lpa.tags.deleteDescription": "Odstraní štítek a zruší jeho přiřazení ke všem otázkám. Tuto akci nelze vrátit zpět.",
    "mod_lpa.tags.confirmDelete": "Smazat",
    "mod_lpa.tags.createSuccess": "Štítek vytvořen",
    "mod_lpa.tags.createError": "Nepodařilo se vytvořit štítek",
    "mod_lpa.tags.updateSuccess": "Štítek aktualizován",
    "mod_lpa.tags.updateError": "Nepodařilo se aktualizovat štítek",
    "mod_lpa.tags.deleteSuccess": "Štítek smazán",
    "mod_lpa.tags.deleteError": "Nepodařilo se smazat štítek",

    // LPA Questions — tag integration
    "mod_lpa.questions.manageTags": "Spravovat štítky",
    "mod_lpa.questions.newTag": "Nový štítek",
    "mod_lpa.questions.createTag": "Vytvořit štítek",
    "mod_lpa.questions.createTagHint": "Rychle vytvořte štítek a přiřaďte ho k této otázce.",

    // LPA Schedules — frequency labels
    "mod_lpa.schedules.freq.perShift": "Každou směnu",
    "mod_lpa.schedules.freq.daily": "Denně",
    "mod_lpa.schedules.freq.weekly": "Týdně",
    "mod_lpa.schedules.freq.monthly": "Měsíčně",
    "mod_lpa.schedules.freq.quarterly": "Čtvrtletně",

    // LPA Schedules — form dialog
    "mod_lpa.schedules.form.createTitle": "Nový plán",
    "mod_lpa.schedules.form.editTitle": "Upravit plán",
    "mod_lpa.schedules.form.createDescription": "Definujte novou vrstvu plánu pro tento audit. Každá vrstva určuje, kdo audituje, jak často a kdy.",
    "mod_lpa.schedules.form.editDescription": "Aktualizujte vrstvu plánu. Změny se projeví pouze u budoucích (dosud negenerovaných) instancí.",
    "mod_lpa.schedules.form.nameLabel": "Název plánu",
    "mod_lpa.schedules.form.nameHint": "Popisný název této vrstvy, např. 'Vrstva 1 – operátor denně' nebo 'Nadřízený týdenní kontrola'.",
    "mod_lpa.schedules.form.namePlaceholder": "např. Vrstva 1 – operátor denně",
    "mod_lpa.schedules.form.frequencyLabel": "Frekvence",
    "mod_lpa.schedules.form.frequencyHint": "Jak často se generují instance auditu. 'Každou směnu' vytvoří jednu instanci na směnu; 'Denně' jednu za den atd.",
    "mod_lpa.schedules.form.auditorLabel": "Auditor",
    "mod_lpa.schedules.form.auditorHint": "Osoba přiřazená k provádění této auditní vrstvy. Může být ponechána prázdná — ale instance nelze generovat bez auditora.",
    "mod_lpa.schedules.form.loadingUsers": "Načítání uživatelů...",
    "mod_lpa.schedules.form.selectAuditor": "Vyberte auditora...",
    "mod_lpa.schedules.form.searchAuditor": "Hledat podle jména nebo e-mailu...",
    "mod_lpa.schedules.form.noUsersFound": "Žádní uživatelé nenalezeni.",
    "mod_lpa.schedules.form.noAuditorWarning": "Není přiřazen auditor — instance nelze generovat, dokud nebude auditor nastaven.",
    "mod_lpa.schedules.form.startDateLabel": "Datum zahájení",
    "mod_lpa.schedules.form.endDateLabel": "Datum ukončení",
    "mod_lpa.schedules.form.endDateHint": "Ponechte prázdné pro neomezený plán. Po tomto datu se nebudou generovat žádné instance.",
    "mod_lpa.schedules.form.activeLabel": "Aktivní",
    "mod_lpa.schedules.form.activeDescription": "Neaktivní plány jsou pozastaveny a nebudou generovat nové instance.",
    "mod_lpa.schedules.form.cancel": "Zrušit",
    "mod_lpa.schedules.form.saveChanges": "Uložit změny",
    "mod_lpa.schedules.form.create": "Vytvořit plán",

    // LPA Schedules — list section
    "mod_lpa.schedules.inactive": "Neaktivní",
    "mod_lpa.schedules.noAuditor": "Bez auditora",
    "mod_lpa.schedules.noAuditorHint": "Instance nelze generovat bez přiřazeného auditora.",
    "mod_lpa.schedules.questionCountTooltip": "{active} aktivních / {total} celkem otázek",
    "mod_lpa.schedules.empty": "Zatím nejsou nakonfigurovány žádné plány. Přidejte vrstvu plánu pro definování kdo audituje, jak často a které otázky.",
    "mod_lpa.schedules.addFirst": "Přidat první plán",
    "mod_lpa.schedules.add": "Přidat plán",
    "mod_lpa.schedules.deleteTitle": "Smazat plán?",
    "mod_lpa.schedules.deleteDescription": "Trvale smaže tento plán a všechna přiřazení otázek. Tuto akci nelze vrátit zpět.",
    "mod_lpa.schedules.deleteCancel": "Zrušit",
    "mod_lpa.schedules.deleteConfirm": "Smazat",

    // LPA Schedules — detail page
    "mod_lpa.schedules.detail.notFound": "Plán nenalezen",
    "mod_lpa.schedules.detail.notFoundHint": "Tento plán mohl být smazán nebo k němu nemáte přístup.",
    "mod_lpa.schedules.detail.backToAudit": "Zpět na audit",
    "mod_lpa.schedules.detail.indefinite": "Neomezený",

    // LPA Schedules — toast messages
    "mod_lpa.schedules.createSuccess": "Plán vytvořen",
    "mod_lpa.schedules.createError": "Nepodařilo se vytvořit plán",
    "mod_lpa.schedules.updateSuccess": "Plán aktualizován",
    "mod_lpa.schedules.updateError": "Nepodařilo se aktualizovat plán",
    "mod_lpa.schedules.deleteSuccess": "Plán smazán",
    "mod_lpa.schedules.deleteError": "Nepodařilo se smazat plán",
    "mod_lpa.schedules.syncSuccess": "Otázky aktualizovány",
    "mod_lpa.schedules.syncError": "Nepodařilo se aktualizovat otázky",

    // LPA Schedules — question assignment
    "mod_lpa.schedules.questions.title": "Přiřazené otázky",
    "mod_lpa.schedules.questions.active": "aktivních",
    "mod_lpa.schedules.questions.total": "celkem",
    "mod_lpa.schedules.questions.reset": "Obnovit",
    "mod_lpa.schedules.questions.save": "Uložit",
    "mod_lpa.schedules.questions.filterByTag": "Štítky:",
    "mod_lpa.schedules.questions.clearFilters": "Vymazat",
    "mod_lpa.schedules.questions.searchPlaceholder": "Hledat otázky...",
    "mod_lpa.schedules.questions.noMatch": "Žádné otázky neodpovídají aktuálnímu filtru.",
    "mod_lpa.schedules.questions.noQuestions": "V bance otázek nejsou žádné otázky. Nejprve přidejte otázky.",
    "mod_lpa.schedules.questions.protectedHint": "Tato otázka má odpovědi z auditů a nelze ji odebrat. Můžete ji místo toho deaktivovat.",
    "mod_lpa.schedules.questions.questionInactive": "Neaktivní v bance",
    "mod_lpa.schedules.questions.edit": "Upravit",
    "mod_lpa.schedules.questions.cancelEdit": "Zrušit",
    "mod_lpa.schedules.questions.noneAssigned": "Zatím nejsou přiřazeny žádné otázky.",
    "mod_lpa.schedules.questions.addQuestions": "Přidat otázky",
    "mod_lpa.schedules.questions.estimatedRange": "Odhad: {min}-{max} min",
    "mod_lpa.schedules.questions.estimatedSingle": "Odhad: {value} min",
    "mod_lpa.schedules.questions.estimatedMissing": "Odhad: bez dat",
    "mod_lpa.schedules.questions.estimatedHint": "Odhad se počítá z aktivních otázek jako 75 %-150 % jejich nastavené délky, zaokrouhlené na nejbližších 5 minut.",

    // LPA Instances — status labels
    "mod_lpa.instances.status.pending": "Čeká",
    "mod_lpa.instances.status.inProgress": "Probíhá",
    "mod_lpa.instances.status.completed": "Dokončeno",
    "mod_lpa.instances.status.overdue": "Po termínu",
    "mod_lpa.instances.status.skipped": "Přeskočeno",
    "mod_lpa.instances.status.cancelled": "Zrušeno",

    // LPA Instances — status descriptions (status dialog)
    "mod_lpa.instances.statusDesc.pending": "Obnovit na čekající — auditor bude muset tuto instanci dokončit.",
    "mod_lpa.instances.statusDesc.skipped": "Přeskočit tuto instanci — nebude vyžadována k dokončení.",
    "mod_lpa.instances.statusDesc.cancelled": "Zrušit tuto instanci — bude označena jako zrušená a odebrána z aktivního zobrazení.",

    // LPA Instances — timeline section
    "mod_lpa.instances.timelineTitle": "Časová osa instancí",
    "mod_lpa.instances.timelineDescription": "Chronologický přehled všech instancí auditu. Zmrazené instance jsou uzamčeny; plánované zobrazují budoucí výskyty podle vzoru plánu.",
    "mod_lpa.instances.helpTitle": "Zmrazené vs. plánované",
    "mod_lpa.instances.helpFrozen": "Zmrazené instance jsou uzamčeny v databázi. Změny v plánu (auditor, frekvence, otázky) je NEOVLIVNÍ.",
    "mod_lpa.instances.helpProjected": "Plánované instance jsou vypočítány ze vzoru plánu pro náhled. Po vygenerování se stanou zmrazenými.",
    "mod_lpa.instances.frozenTooltip": "Vygenerováno a zmrazeno — změny plánu tuto instanci neovlivní",
    "mod_lpa.instances.projectedTooltip": "Plánováno — zatím nevygenerováno. Stane se reálným při dalším generování.",
    "mod_lpa.instances.planned": "Plánováno",
    "mod_lpa.instances.empty": "Zatím žádné instance. Vygenerujte instance ze stránky detailu plánu, nebo se zde objeví po automatickém vygenerování.",

    // LPA Instances — filter pills
    "mod_lpa.instances.filter.all": "Vše",

    // LPA Instances — actions dropdown
    "mod_lpa.instances.actions.changeStatus": "Změnit stav",
    "mod_lpa.instances.actions.reassignAuditor": "Přeřadit auditora",
    "mod_lpa.instances.actions.delete": "Smazat",
    "mod_lpa.instances.actions.noActions": "Žádné akce nejsou k dispozici",

    // LPA Instances — status change dialog
    "mod_lpa.instances.statusDialog.title": "Změnit stav instance",
    "mod_lpa.instances.statusDialog.description": "Aktualizujte stav této instance auditu. Tato akce je zaznamenána.",
    "mod_lpa.instances.statusDialog.current": "Aktuální:",
    "mod_lpa.instances.statusDialog.newStatus": "Nový stav",
    "mod_lpa.instances.statusDialog.select": "Vyberte stav...",
    "mod_lpa.instances.statusDialog.noTransitions": "Pro tuto instanci nejsou dostupné žádné změny stavu.",
    "mod_lpa.instances.statusDialog.cancel": "Zrušit",
    "mod_lpa.instances.statusDialog.confirm": "Aktualizovat stav",

    // LPA Instances — auditor reassignment dialog
    "mod_lpa.instances.auditorDialog.title": "Přeřadit auditora",
    "mod_lpa.instances.auditorDialog.description": "Přeřaďte tuto instanci náhradnímu auditorovi. Výchozí nastavení plánu zůstane nezměněno.",
    "mod_lpa.instances.auditorDialog.help": "Přeřazení změní pouze tuto jednu instanci — výchozí auditor plánu zůstane nezměněn. Použijte pro zastupování při dovolené nebo jednorázové substituce.",
    "mod_lpa.instances.auditorDialog.current": "Aktuální",
    "mod_lpa.instances.auditorDialog.new": "Nový",
    "mod_lpa.instances.auditorDialog.selectPlaceholder": "Vyberte...",
    "mod_lpa.instances.auditorDialog.selectAuditor": "Vyberte náhradního auditora...",
    "mod_lpa.instances.auditorDialog.search": "Hledat podle jména nebo e-mailu...",
    "mod_lpa.instances.auditorDialog.noUsers": "Žádní uživatelé nenalezeni.",
    "mod_lpa.instances.auditorDialog.loading": "Načítání uživatelů...",
    "mod_lpa.instances.auditorDialog.roleLabel": "Role v továrně",
    "mod_lpa.instances.auditorDialog.cancel": "Zrušit",
    "mod_lpa.instances.auditorDialog.confirm": "Přeřadit",

    // LPA Instances — delete dialog
    "mod_lpa.instances.deleteDialog.title": "Smazat instanci?",
    "mod_lpa.instances.deleteDialog.description": "Trvale smaže instanci auditu pro '{schedule}' ({period}). Tuto akci nelze vrátit zpět.",
    "mod_lpa.instances.deleteDialog.cancel": "Zrušit",
    "mod_lpa.instances.deleteDialog.confirm": "Smazat",

    // LPA Instances — toast messages (from hooks)
    "mod_lpa.instances.generateSuccess": "Instance vygenerována",
    "mod_lpa.instances.generateError": "Nepodařilo se vygenerovat instanci",
    "mod_lpa.instances.statusUpdateSuccess": "Stav instance aktualizován",
    "mod_lpa.instances.statusUpdateError": "Nepodařilo se aktualizovat stav",
    "mod_lpa.instances.auditorUpdateSuccess": "Auditor přeřazen",
    "mod_lpa.instances.auditorUpdateError": "Nepodařilo se přeřadit auditora",
    "mod_lpa.instances.deleteSuccess": "Instance smazána",
    "mod_lpa.instances.deleteError": "Nepodařilo se smazat instanci",

    // LPA Instances — schedule detail page section
    "mod_lpa.instances.scheduleInstancesTitle": "Vygenerované instance",
    "mod_lpa.instances.generateHelp.title": "Manuální generování instancí",
    "mod_lpa.instances.generateHelp.body": "Každé kliknutí vygeneruje jednu instanci pro další období. Instance jsou okamžitě zmrazeny — změny plánu je neovlivní. V produkci se instance generují automaticky.",
    "mod_lpa.instances.generateNext": "Vygenerovat další",
    "mod_lpa.instances.generateNoAuditor": "Pro generování instancí přiřaďte auditora.",
    "mod_lpa.instances.generateNoPeriod": "Žádná další období k vygenerování (plán mohl skončit).",
    "mod_lpa.instances.generateNextHint": "Vygenerovat zmrazenou instanci pro {period}",
    "mod_lpa.instances.nextPeriodLabel": "Další období: {period}",
    "mod_lpa.instances.scheduleEmpty": "Zatím nebyly vygenerovány žádné instance. Použijte tlačítko 'Vygenerovat další' pro vytvoření první instance tohoto plánu.",

    "mod_energy.energy_management.subtitle": "Sledujte energetická KPI a přejděte do výrobních oblastí.",
    "mod_energy.energy_management.updating": "Aktualizace...",
    "mod_energy.energy_management.refresh": "Obnovit",
    "mod_energy.energy_management.settings": "Nastavení",
    "mod_energy.energy_management.unsMapper": "UNS mapování",
    "mod_energy.energy_management.stats.exposedValues": "Exponované hodnoty",
    "mod_energy.energy_management.stats.mapped": "namapováno",
    "mod_energy.energy_management.stats.areas": "Oblasti",
    "mod_energy.energy_management.stats.lines": "Linky",
    "mod_energy.energy_management.stats.stations": "Stanice",
    "mod_energy.energy_management.stats.covered": "pokryto",
    "mod_energy.energy_management.tabs.overview": "Přehled",
    "mod_energy.energy_management.tabs.areas": "Podle oblasti",
    "mod_energy.energy_management.empty.factory.title": "Není vybraná továrna",
    "mod_energy.energy_management.empty.factory.description": "Pro zobrazení energetických dat vyberte továrnu.",
    "mod_energy.energy_management.empty.exposed.title": "Nenalezeny exponované hodnoty",
    "mod_energy.energy_management.empty.exposed.description": "Zkontrolujte, že exponované hodnoty modulu energie jsou registrované.",
    "mod_energy.energy_management.kpis.title": "KPI továrny",
    "mod_energy.energy_management.kpis.description": "Přehled klíčových energetických hodnot.",
    "mod_energy.energy_management.areaHighlights.title": "Zvýraznění oblastí",
    "mod_energy.energy_management.areaHighlights.description": "Rychlý pohled na výkon a spotřebu podle oblasti.",
    "mod_energy.energy_management.areaHighlights.tracked": "sledovaná KPI",
    "mod_energy.energy_management.areaHighlights.empty": "Žádné oblasti nejsou nastavené",
    "mod_energy.energy_management.areaHighlights.cta": "Nastavit strukturu továrny →",
    "mod_energy.energy_management.levelOverview.title": "Energetické signály",
    "mod_energy.energy_management.levelOverview.description": "Vyberte úroveň pro zobrazení všech exponovaných hodnot s živými KPI a trendy.",
    "mod_energy.energy_management.levelOverview.selectPlaceholder": "Vyberte úroveň",
    "mod_energy.energy_management.level.factory": "Továrna",
    "mod_energy.energy_management.level.area": "Oblast",
    "mod_energy.energy_management.level.line": "Linka",
    "mod_energy.energy_management.level.station": "Stanice",
    "mod_energy.energy_management.group.power.title": "Výkon",
    "mod_energy.energy_management.group.power.description": "Aktivní, jalový a zdánlivý výkon napříč fázemi.",
    "mod_energy.energy_management.group.voltage.title": "Napětí",
    "mod_energy.energy_management.group.voltage.description": "Napětí mezi fází a nulou i mezi fázemi.",
    "mod_energy.energy_management.group.current.title": "Proud",
    "mod_energy.energy_management.group.current.description": "Proud na fázích a na nulovém vodiči.",
    "mod_energy.energy_management.group.energy.title": "Energie",
    "mod_energy.energy_management.group.energy.description": "Spotřeba a export pro vybranou úroveň.",
    "mod_energy.energy_management.group.quality.title": "Kvalita",
    "mod_energy.energy_management.group.quality.description": "Účiník, frekvence a harmonické zkreslení.",
    "mod_energy.energy_management.group.other.title": "Další signály",
    "mod_energy.energy_management.group.other.description": "Ostatní exponované hodnoty registrované pro modul.",
    "mod_energy.energy_management.areas.empty.title": "Žádné oblasti nejsou nastavené",
    "mod_energy.energy_management.areas.empty.description": "Nastavte strukturu továrny pro členění energetiky podle oblastí.",
    "mod_energy.energy_management.areas.empty.cta": "Nastavit strukturu továrny",
    "mod_energy.energy_management.areas.values": "Hodnoty oblasti",
    "mod_energy.energy_management.areas.lines": "linky",
    "mod_energy.energy_management.areas.stations": "stanice",
    "mod_energy.energy_management.metric.noDescription": "Bez popisu",
    "mod_energy.energy_management.metric.mapped": "Namapováno",
    "mod_energy.energy_management.metric.unmapped": "Nenamapováno",
    "mod_energy.energy_management.metric.noMapping": "Bez mapování",
    "mod_energy.energy_management.metric.dailyAverage": "Denní průměr",
    "mod_energy.energy_management.metric.viewTrend": "Zobrazit trend",
    "mod_energy.energy_management.metric.selectDatapoint": "Vybrat datapoint",
    "mod_energy.energy_management.metric.unknown": "Neznámé",
    "mod_energy.energy_management.grid.empty": "Nejsou definované exponované hodnoty.",
    "mod_energy.energy_management.selector.title": "Vyberte datapoint",
    "mod_energy.energy_management.selector.titleFallback": "Vyberte datapoint",
    "mod_energy.energy_management.selector.description": "Přiřaďte datapoint pro vybranou úroveň.",
    "mod_energy.energy_management.selector.descriptionFallback": "Vyberte existující mapování datapointu.",
    "mod_energy.energy_management.saving": "Ukládání mapování...",
    "mod_energy.energy_management.toast.mapped": "Exponovaná hodnota namapována",
    "mod_energy.energy_management.toast.failed": "Mapování se nepodařilo",
    "mod_energy.energy_management.toast.permission": "Nemáte oprávnění upravovat mapování",
    "mod_energy.energy_management.settings.title": "Nastavení energie",
    "mod_energy.energy_management.settings.description": "Pochopte exponované hodnoty a spravujte mapování napříč továrnou.",
    "mod_energy.energy_management.settings.nav.overview": "Přehled",
    "mod_energy.energy_management.settings.nav.exposed": "Exponované hodnoty",
    "mod_energy.energy_management.settings.nav.hierarchy": "Hierarchie továrny",
    "mod_energy.energy_management.settings.overview.title": "Vítejte v nastavení energie",
    "mod_energy.energy_management.settings.overview.subtitle": "Exponované hodnoty jsou spojnicí mezi IoT signály a energetickým dashboardem.",
    "mod_energy.energy_management.settings.overview.body": "Každá exponovaná hodnota reprezentuje klíčový energetický signál. Připojte datapoint a odemkněte KPI, trendy a srovnání napříč hierarchií.",
    "mod_energy.energy_management.settings.overview.step1.label": "Krok 1",
    "mod_energy.energy_management.settings.overview.step1.title": "Zkontrolujte exponované hodnoty",
    "mod_energy.energy_management.settings.overview.step1.description": "Ověřte, že všechny potřebné signály existují pro modul energie.",
    "mod_energy.energy_management.settings.overview.step2.label": "Krok 2",
    "mod_energy.energy_management.settings.overview.step2.title": "Namapujte datapointy",
    "mod_energy.energy_management.settings.overview.step2.description": "Přiřaďte živé datapointy k exponovaným hodnotám na libovolné úrovni.",
    "mod_energy.energy_management.settings.overview.step3.label": "Krok 3",
    "mod_energy.energy_management.settings.overview.step3.title": "Sledujte aktualizace KPI",
    "mod_energy.energy_management.settings.overview.step3.description": "Dashboard okamžitě reaguje na nová mapování s živými metrikami.",
    "mod_energy.energy_management.settings.exposed.title": "Exponované hodnoty energie",
    "mod_energy.energy_management.settings.exposed.subtitle": "Tyto hodnoty definují signály energetického modulu.",
    "mod_energy.energy_management.settings.exposed.empty": "Pro modul energie nejsou registrovány žádné exponované hodnoty.",
    "mod_energy.energy_management.settings.hierarchy.title": "Mapování hierarchie",
    "mod_energy.energy_management.settings.hierarchy.subtitle": "Přiřaďte exponované hodnoty na každé úrovni továrny.",
    "mod_energy.energy_management.settings.hierarchy.factory": "Továrna",
    "mod_energy.energy_management.settings.hierarchy.empty": "Zatím nejsou nastaveny žádné oblasti.",

    "core.datapointSelector.title": "Vybrat datapoint",
    "core.datapointSelector.description": "Vyberte existující mapování datapointu.",
    "core.datapointSelector.scopedHeading": "Datapointy na této úrovni",
    "core.datapointSelector.scopedEmpty": "Na této úrovni nebyly nalezeny datapointy.",
    "core.datapointSelector.otherHeading": "Procházet všechny datapointy",
    "core.datapointSelector.search": "Hledat ve všech datapointech...",
    "core.datapointSelector.empty": "Žádné datapointy neodpovídají vyhledávání.",
    "core.datapointSelector.otherResults": "Další datapointy",

    "core.feedback.trigger": "Zpětná vazba",
    "core.feedback.menu.title": "Odeslat zpětnou vazbu k produktu",
    "core.feedback.menu.issue": "Nahlásit problém",
    "core.feedback.menu.feature": "Navrhnout funkci",
    "core.feedback.menu.hint": "Můžete přiložit snímek obrazovky a nedávný záznam relace.",
    "core.feedback.unavailable.title": "Zpětná vazba není dostupná",
    "core.feedback.unavailable.description": "Zkuste to prosím za chvíli znovu. Widget se stále načítá.",
    "core.feedback.openError.title": "Formulář zpětné vazby se nepodařilo otevřít",
    "core.feedback.openError.description": "Obnovte stránku a zkuste to znovu.",
    "core.feedback.issue.formTitle": "Nahlásit problém",
    "core.feedback.issue.submit": "Odeslat hlášení problému",
    "core.feedback.issue.placeholder": "Co se stalo, co jste očekávali a jaké kroky máme vyzkoušet?",
    "core.feedback.feature.formTitle": "Navrhnout funkci",
    "core.feedback.feature.submit": "Odeslat návrh funkce",
    "core.feedback.feature.placeholder": "Co byste chtěli zlepšit a jaký problém by to vyřešilo?",

    "core.errorBoundary.title": "Něco se pokazilo",
    "core.errorBoundary.description": "Došlo k neočekávané chybě rozhraní. Problém byl automaticky nahlášen.",
    "core.errorBoundary.eventId": "ID události Sentry",
    "core.errorBoundary.tryAgain": "Zkusit znovu",
    "core.errorBoundary.goHome": "Přejít na úvod",

    // Scrap Entry Module
    "core.scrap.title": "Zadání zmetků",
    "core.scrap.subtitle": "Denní sledování ztrát na výrobní lince",
    "core.scrap.viewing": "Zobrazeno",
    "core.scrap.collapseAll": "Sbalit vše",
    "core.scrap.expandAll": "Rozbalit vše",
    "core.scrap.noAreas": "Nebyly nalezeny žádné výrobní oblasti. Nejprve nastavte strukturu továrny.",
    "core.scrap.noFactory": "Pro zobrazení zmetků vyberte továrnu.",
    "core.scrap.lines": "linky",
    "core.scrap.addEntry": "Přidat záznam",
    "core.scrap.entryAdded": "Záznam o zmetku přidán",
    "core.scrap.entryDeleted": "Záznam smazán",
    "core.scrap.error": "Chyba",
    "core.scrap.invalidAmount": "Neplatná částka",
    "core.scrap.notePlaceholder": "Poznámka (volitelné)",
    "core.scrap.less": "Méně",
    "core.scrap.more": "Více",
    "core.scrap.add": "Přidat",
    "core.scrap.article": "Artikl",
    "core.scrap.station": "Stanice",
    "core.scrap.noStation": "Bez stanice",
    "core.scrap.deleteEntry": "Smazat záznam?",
    "core.scrap.deleteConfirm": "Odstranit záznam o zmetku €{amount}? Tuto akci nelze vrátit.",
    "core.scrap.cancel": "Zrušit",
    "core.scrap.delete": "Smazat",
    "core.scrap.done": "Hotovo",
    "core.scrap.pending": "Čeká",
    "core.scrap.missing": "Chybí",

    // Customer Complaints Module
    "core.complaints.title": "Zákaznické reklamace",
    "core.complaints.subtitle": "Evidence a správa reklamací s propojením na 8D",
    "core.complaints.newComplaint": "Nová reklamace",
    "core.complaints.createTitle": "Zaznamenat reklamaci",
    "core.complaints.createDescription": "Vyplňte detaily zákaznické reklamace. Pole označená * jsou povinná.",
    "core.complaints.detailTitle": "Detail reklamace",
    "core.complaints.detailDescription": "Zobrazit a upravit informace o reklamaci, spravovat přílohy",
    "core.complaints.customer": "Zákazník",
    "core.complaints.complaintDate": "Datum reklamace",
    "core.complaints.productionDate": "Datum výroby",
    "core.complaints.status": "Stav",
    "core.complaints.status.draft": "Koncept",
    "core.complaints.status.complaint_recorded": "Zaznamenáno",
    "core.complaints.status.in_progress": "Řeší se",
    "core.complaints.status.closed": "Uzavřeno",
    "core.complaints.article": "Artikl / Produkt",
    "core.complaints.location": "Lokace",
    "core.complaints.customerReference": "Reference zákazníka",
    "core.complaints.serialNumber": "Sériové číslo",
    "core.complaints.comment": "Komentář",
    "core.complaints.attachments": "Přílohy",
    "core.complaints.attachNote": "Dokumenty můžete připojit po vytvoření reklamace.",
    "core.complaints.noAttachments": "Zatím bez příloh",
    "core.complaints.uploadFile": "Nahrát soubor",
    "core.complaints.uploading": "Nahrávání...",
    "core.complaints.labelPlaceholder": "Popisek (volitelné)",
    "core.complaints.saveChanges": "Uložit změny",
    "core.complaints.viewEdit": "Zobrazit / Upravit",
    "core.complaints.linkTo8D": "Propojit s 8D",
    "core.complaints.created": "Reklamace vytvořena",
    "core.complaints.createdDescription": "Zákaznická reklamace byla úspěšně zaznamenána.",
    "core.complaints.updated": "Reklamace aktualizována",
    "core.complaints.fileUploaded": "Soubor nahrán",
    "core.complaints.fileDeleted": "Soubor smazán",
    "core.complaints.notFound": "Reklamace nenalezena",
    "core.complaints.selectCustomer": "Vyberte zákazníka",
    "core.complaints.fileTooLarge": "Soubor je příliš velký (max 50MB)",
    "core.complaints.uploadFailed": "Nahrávání souboru selhalo",
    "core.complaints.deleteFailed": "Smazání souboru selhalo",
    "core.complaints.updateFailed": "Aktualizace selhala",
    "core.complaints.dashboard": "Přehled",
    "core.complaints.allComplaints": "Všechny reklamace",
    "core.complaints.recentComplaints": "Nedávné reklamace",
    "core.complaints.allStatuses": "Všechny stavy",
    "core.complaints.allCustomers": "Všichni zákazníci",
    "core.complaints.clear": "Vymazat",
    "core.complaints.complaintsCount": "reklamací",
    "core.complaints.noComplaints": "Zatím žádné reklamace.",
    "core.complaints.createdBy": "Vytvořil",

    // Common
    "common.cancel": "Zrušit",
    "common.loading": "Načítání...",
    "common.next": "Další",
    "common.optional": "volitelné",
    "common.previous": "Předchozí",
    "common.retry": "Zkusit znovu",

    // Super Admin Module
    "superadmin.dashboard.title": "Super Admin",
    "superadmin.accessDenied.title": "Přístup odepřen",
    "superadmin.error.title": "Chyba",
    "superadmin.error.loadingAdmins": "Nepodařilo se načíst super adminy",

    "superadmin.tabs.admins": "Admini",
    "superadmin.tabs.tenants": "Tenanty",
    "superadmin.tabs.users": "Uživatelé",

    // Admins tab
    "superadmin.admins.title": "Super Administrátoři",
    "superadmin.admins.description": "Uživatelé s plným přístupem k systému",
    "superadmin.admins.badge": "Super Admin",
    "superadmin.admins.empty": "Žádní super administrátoři nebyli nalezeni",

    // Tenants tab
    "superadmin.tenants.title": "Tenanty",
    "superadmin.tenants.addButton": "Přidat tenanta",
    "superadmin.tenants.active": "Aktivní",
    "superadmin.tenants.inactive": "Neaktivní",
    "superadmin.tenants.factories": "továrny",
    "superadmin.tenants.noFactories": "Žádné továrny",
    "superadmin.tenants.createTitle": "Vytvořit tenanta",
    "superadmin.tenants.createDescription": "Vytvořte nového tenanta pro vaši platformu",
    "superadmin.tenants.editTitle": "Upravit tenanta",
    "superadmin.tenants.editDescription": "Aktualizujte nastavení tenanta",
    "superadmin.tenants.nameLabel": "Název",
    "superadmin.tenants.namePlaceholder": "Název společnosti",
    "superadmin.tenants.codeLabel": "Kód",
    "superadmin.tenants.codePlaceholder": "acme",
    "superadmin.tenants.codeHint": "Unikátní identifikátor pro URL a integrace",
    "superadmin.tenants.languageLabel": "Sekundární jazyk",
    "superadmin.tenants.languagePlaceholder": "Vyberte jazyk",
    "superadmin.tenants.languageNone": "Žádný",
    "superadmin.tenants.microsoftLabel": "Microsoft Entra (Azure AD)",
    "superadmin.tenants.createButton": "Vytvořit",
    "superadmin.tenants.updateButton": "Uložit změny",
    "superadmin.tenants.createSuccess": "Tenant vytvořen",
    "superadmin.tenants.createError": "Nepodařilo se vytvořit tenanta",
    "superadmin.tenants.updateSuccess": "Tenant aktualizován",
    "superadmin.tenants.updateError": "Nepodařilo se aktualizovat tenanta",

    // Users tab
    "superadmin.users.title": "Auth uživatelé",
    "superadmin.users.searchPlaceholder": "Hledat podle emailu...",
    "superadmin.users.filterAll": "Všichni",
    "superadmin.users.filterWithProfile": "S profilem",
    "superadmin.users.filterWithoutProfile": "Bez profilu",
    "superadmin.users.empty": "Žádní uživatelé nebyli nalezeni",
    "superadmin.users.errorTitle": "Nepodařilo se načíst uživatele",
    "superadmin.users.page": "Stránka",
    "superadmin.users.colEmail": "Email",
    "superadmin.users.colProfile": "Profil",
    "superadmin.users.colTenants": "Tenanty",
    "superadmin.users.colLastSignIn": "Poslední přihlášení",
    "superadmin.users.colCreated": "Vytvořeno",
    "superadmin.users.hasProfile": "Má profil",
    "superadmin.users.noProfile": "Bez profilu",
    "superadmin.users.noTenants": "Žádné tenanty",
    "superadmin.users.createProfile": "Vytvořit profil",
    "superadmin.users.assignTenant": "Přiřadit tenanta",

    // Create Profile Dialog
    "superadmin.users.createProfileTitle": "Vytvořit profil",
    "superadmin.users.emailLabel": "Email",
    "superadmin.users.emailHint": "Email je převzat z auth účtu",
    "superadmin.users.nameLabel": "Celé jméno",
    "superadmin.users.namePlaceholder": "Jan Novák",
    "superadmin.users.createProfileButton": "Vytvořit profil",
    "superadmin.users.profileCreated": "Profil vytvořen",
    "superadmin.users.profileCreateError": "Nepodařilo se vytvořit profil",

    // Assign Tenant Dialog
    "superadmin.users.assignTenantTitle": "Přiřadit tenanta",
    "superadmin.users.currentMemberships": "Aktuální členství",
    "superadmin.users.selectTenant": "Vybrat tenanta",
    "superadmin.users.selectTenantPlaceholder": "Vyberte tenanta...",
    "superadmin.users.assignButton": "Přiřadit",
    "superadmin.users.tenantAssigned": "Tenant přiřazen",
    "superadmin.users.tenantAssignError": "Nepodařilo se přiřadit tenanta",

    // Auth - Email Confirmation
    "auth.confirmation.verifying": "Ověřování e-mailu",
    "auth.confirmation.pleaseWait": "Počkejte prosím, ověřujeme vaši e-mailovou adresu...",
    "auth.confirmation.success": "E-mail ověřen!",
    "auth.confirmation.successDescription": "Váš e-mail byl úspěšně ověřen. Nyní máte přístup ke svému účtu.",
    "auth.confirmation.error": "Ověření se nezdařilo",
    "auth.confirmation.errorDescription": "Nepodařilo se nám ověřit váš e-mail. Odkaz mohl vypršet nebo již byl použit.",
    "auth.confirmation.alreadyConfirmed": "Již ověřeno",
    "auth.confirmation.alreadyConfirmedDescription": "Váš e-mail již mohl být ověřen. Přihlaste se prosím.",
    "auth.confirmation.continue": "Pokračovat na přehled",
    "auth.confirmation.goToSignIn": "Přejít na přihlášení",
    "auth.confirmation.needHelp": "Pokud máte i nadále problémy, kontaktujte prosím podporu.",

    // Auth - Check Email Page
    "auth.checkEmail.title": "Zkontrolujte e-mail",
    "auth.checkEmail.description": "Poslali jsme vám potvrzovací odkaz. Zkontrolujte prosím svou schránku a klikněte na odkaz pro aktivaci účtu.",
    "auth.checkEmail.tip1": "Doručení e-mailu může trvat několik minut.",
    "auth.checkEmail.tip2": "Pokud e-mail nevidíte, zkontrolujte složku spam.",
    "auth.checkEmail.backToSignIn": "Zpět na přihlášení",

    // Auth - No Access Page
    "auth.noAccess.title": "Čeká na schválení",
    "auth.noAccess.description": "Váš účet je nastaven, ale zatím nemáte přístup k žádné továrně.",
    "auth.noAccess.whatHappensNext": "Co se stane dál?",
    "auth.noAccess.step1": "Administrátor vás musí přiřadit k organizaci a udělit přístup k továrně.",
    "auth.noAccess.step2": "Po schválení budete mít přístup k přiřazeným modulům továrny.",
    "auth.noAccess.signOut": "Odhlásit se",
    "auth.noAccess.helpText": "Pokud si myslíte, že jde o chybu, kontaktujte prosím správce systému nebo IT oddělení."
  },
};

export const getUiTranslation = (language: LanguageCode, key: string, fallback: string) => {
  return UI_TRANSLATIONS[language]?.[key] || fallback;
};
